<div *ngIf="contactDepartment">
  <mat-toolbar>
    <span *ngIf="contactDepartment.contactCompanyId">
      <mat-icon>source_environment</mat-icon> <micro-contactCompany-lookup [contactCompanyId]="contactDepartment.contactCompanyId"></micro-contactCompany-lookup> |
    </span>
    <mat-icon>business_center</mat-icon> {{!contactDepartment.id ? 'Create new Contact Department' : contactDepartment.name}}
  </mat-toolbar>

  <div *ngIf="!isEmbedded" class="hbox lightly-padded button-bar">
    <ng-container *ngTemplateOutlet="crudButtons"></ng-container>
  </div>

  <div class="padded">
    <form (ngSubmit)="save()" #form="ngForm" role="form" class="vbox">
      <table class="basicTable vtable">
        <thead>
        <tr>
          <th colspan="100">Contact Department Details</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="isCompanyAdmin">
          <th><micro-valid-label for="company" [model]="company" label="Company"></micro-valid-label></th>
          <td>
            <micro-company-select #company="ngModel"
                                  [(ngModel)]="contactDepartment.companyId"
                                  [required]="true"
                                  [disabled]="auth.companyIdFilter"
                                  [jump]="false"
                                  id="company"
                                  name="company">
            </micro-company-select>
          </td>
        </tr>
        <tr>
          <th><micro-valid-label for="company" [model]="contactCompany" label="Contact Company"></micro-valid-label></th>
          <td>
            <micro-contactCompany-select #contactCompany="ngModel"
                                         [companyId]="companyId"
                                         [(ngModel)]="contactDepartment.contactCompanyId"
                                         [required]="true"
                                         [jump]="false"
                                         [disabled]="!!!companyId"
                                         id="contactCompany"
                                         name="contactCompany">
            </micro-contactCompany-select>
          </td>
        </tr>
        <tr>
          <th><micro-valid-label for="name" [model]="name" label="Department"></micro-valid-label></th>
          <td>
            <input #name="ngModel"
                   [(ngModel)]="contactDepartment.name"
                   autocomplete="false" autocorrect="off" autocapitalize="none"
                   [required]="true"
                   type="text"
                   placeholder="Name"
                   id="name" name="name">
          </td>
        </tr>
        </tbody>
      </table>
      <micro-contact-picklist *ngIf="contactDepartment?.id"
                              [contactCompanyId]="contactDepartment?.contactCompanyId"
                              [contactDepartmentId]="contactDepartment.id"
                              [(selectedItems)]="contactDepartment.members"
      >
      </micro-contact-picklist>
    </form>
    <div *ngIf="isEmbedded" class="padded-top">
      <ng-container *ngTemplateOutlet="crudButtons"></ng-container>
    </div>

    <ng-template #crudButtons>
        <button mat-raised-button class="primary" type="button" (click)="save()"
                [disabled]="!form.form.valid" style="margin-right: 5px;">
          <mat-icon>{{!contactDepartment.id ? 'add' : 'save'}}</mat-icon>
          {{(contactDepartment.id ? 'Update ' : 'Add ')}}
        </button>
        <micro-delete-confirm *ngIf="contactDepartment.id" (onConfirm)="deleteContactDepartment()"></micro-delete-confirm>
    </ng-template>
  </div>
</div>

